import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { clearErrors, getConfirmados } from '../../actions';
import { messageTypeEnum } from '../../enum';
import BasicMessage from '../messages/basicMessage';
import InputField from "../nuevoDocumento/InputField"
import moment from 'moment';
import { ValidarEmisor, ValidarLogin, IsNotNullOrEmptyOrUndefined, addDayToDate, getCurrentDate, dateFormat } from '../../util';
import RenderHeader from '../shared/RenderHeader';
import { Button, Modal } from 'semantic-ui-react'
import ListadoDocumentosConfirmados from './ListadoDocumentosConfirmados';

const FactuasConfirmadas = (props) => {
    const { token } = ValidarLogin(props);
    const { emisor } = ValidarEmisor(props);
    const { getConfirmadosState } = props;
    const [mgType, setMgType] = useState('');
    const [message, setMessage] = useState('');
    const [isActiveModalError, setIsActiveModalError] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(addDayToDate(getCurrentDate(), -30));
    const [fechaFin, setFechaFin] = useState(addDayToDate(getCurrentDate(), + 1));
    const [documentosConfirmados, SetDocumentosConfirmados] = useState([]);

    useEffect(() => {
        props.clearErrors();
        if (token !== null && emisor !== null && fechaInicio && fechaFin) {
            let fechaInicioString = dateFormat(fechaInicio, 'YYYY-MM-DD');
            let fechaFinString = dateFormat(fechaFin, 'YYYY-MM-DD');
            props.getConfirmados(token.access_token, emisor.Identificacion.Numero, fechaInicioString, fechaFinString);
        }
    }, []);

    useEffect(() => {
        if (getConfirmadosState !== null) {
            SetDocumentosConfirmados(getConfirmadosState);
            closeMessages();
            if (getConfirmadosState.length <= 0) {
                setMgType(messageTypeEnum.error);
                setMessage("No hay facturas confirmadas en el rango digitado");
            }
        }
    }, [getConfirmadosState]);

    const setFechaInicioFormat = (value) => {
        if (IsNotNullOrEmptyOrUndefined(value)) {
            let fecha = new Date(value);
            let fechaString = fecha.getUTCFullYear() + "-" + (fecha.getUTCMonth() + 1) + "-" + fecha.getDate();
            setFechaInicio(fechaString);
        }
    };

    const setFechaFinFormat = (value) => {
        if (IsNotNullOrEmptyOrUndefined(value)) {
            let fecha = new Date(value);
            let fechaString = fecha.getUTCFullYear() + "-" + (fecha.getUTCMonth() + 1) + "-" + fecha.getDate();
            setFechaFin(fechaString);
        }
    };

    const listarConfirmados = () => {
        if (token !== null && emisor !== null) {
            let fecha1 = new Date(fechaInicio);
            let fecha2 = new Date(fechaFin);
            if (fecha1 > fecha2) {
                setMgType(messageTypeEnum.error);
                setMessage("El rango de fechas digitado no es válido");
                SetDocumentosConfirmados([]);
            } else {
                let fechaInicioString = dateFormat(fechaInicio, 'YYYY-MM-DD');
                let fechaFinString = dateFormat(fechaFin, 'YYYY-MM-DD');
                props.getConfirmados(token.access_token, emisor.Identificacion.Numero, fechaInicioString, fechaFinString);
            }
        }
    };

    const closeMessages = () => {
        setMgType('');
        setMessage('');
    };
    const closeError = () => {
        setIsActiveModalError(false);
        closeMessages();
    }

    if (token === null) {
        return <Redirect to='/login' />;
    }

    return (
        <>
            <div className="ui Lista-facturas-container">

                <RenderHeader titulo="LISTADO DE FACTURAS CONFIRMADAS" />

                <div className="ui segment stackable row grid desktop">
                    <div className="ui form four wide column">
                        <div className="row">
                            <InputField
                                label="Fecha desde"
                                value={fechaInicio}
                                type="datePicker"
                                placeholder="DD-MM-YYYY"
                                onChange={(e) => setFechaInicioFormat(e?._d)}
                            />
                        </div>
                    </div>
                    <div className="ui form four wide column">
                        <div className="row">
                            <InputField
                                label="Fecha hasta"
                                value={fechaFin}
                                type="datePicker"
                                placeholder="DD-MM-YYYY"
                                onChange={(e) => setFechaFinFormat(e?._d)}
                            />
                        </div>
                    </div>
                    <div className="six wide column center-text">
                        <input type="submit" className="ui but blue inline button custom-file-input" onClick={() => listarConfirmados()} value="Listar confirmados" />
                    </div>
                </div>
                <BasicMessage message={message} type={mgType} onClick={() => closeMessages()} />

                {(documentosConfirmados.length > 0) && (<ListadoDocumentosConfirmados documentos={documentosConfirmados} emisor={emisor} />)}
            </div>
            <Modal
                centered={false}
                size="small"
                open={isActiveModalError}
                onClose={() => setIsActiveModalError(false)}
            >
                <Modal.Header>Error</Modal.Header>
                <Modal.Content>
                    <BasicMessage message={message} type={mgType} onClick={() => closeMessages()} />
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={() => closeError()}>
                        Cerrar
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        loginState: state.loginState,
        getConfirmadosState: state.getConfirmadosState,
        isLoading: state.isLoadingState,
        emisorState: state.emisorState,
    };
};

export default connect(mapStateToProps, { clearErrors, getConfirmados })(FactuasConfirmadas);